<template>
<section class="premium-section">
<h2 class="section-title">Official MDR Reward Snapshot Mechanism</h2>

<p>
At a predefined stage of ecosystem development, the Mudra platform will conduct an official reward snapshot.
</p>

<p>
During the snapshot process, all estimated MDR reward balances accumulated by creators are finalized and recorded.
</p>

<p>
The snapshot captures the total rewards earned by each creator up to that specific point in time.
</p>

<p>
Once the snapshot is completed, these recorded balances are converted into actual MDR token allocations.
</p>

<p>
This mechanism ensures that all creators receive fair recognition for their contributions to the platform before the snapshot occurs.
</p>

</section>
</template>